import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'

// ── Global design system ──────────────────────────────
import './assets/style.css'

import router from './router'
import store from './store'
import axios from './helpers/axios';
import { getUploadBaseUrl, resolveUploadUrl } from './helpers/mediaUrl';
import i18n from './i18n'
import VeeValidate from 'vee-validate';
import * as VueGoogleMaps from 'vue2-google-maps'
import DatetimePicker from 'vuetify-datetime-picker'
import CKEditor from '@ckeditor/ckeditor5-vue2';

import moment from 'moment';
import CountryCodeSelect from 'vue-country-code'
import VueCountryCode from "vue-country-code-select";

Vue.use(VueCountryCode);
Vue.component('country-code-select', CountryCodeSelect)

Vue.filter('formatDate', function(value) {
  if (!value) return 'N/A';
  const date = isNaN(value) ? moment(value) : moment(Number(value));
  return date.isValid() ? date.format('DD MMM, YYYY') : 'N/A';
});

Vue.filter('formatDateTime', function(value) {
  if (!value) return 'N/A';
  const date = isNaN(value) ? moment(value) : moment(Number(value));
  return date.isValid() ? date.format('DD MMM, YYYY · hh:mm A') : 'N/A';
});

Vue.use(VeeValidate);
Vue.use(CKEditor);
Vue.use(DatetimePicker);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBE1s-LuOOBxhJEaXiVYBrWgd0TwGJv3so',
    libraries: 'places',
  }
});

Vue.config.productionTip = false
Vue.prototype.$axios        = axios;
Vue.prototype.$vuetify      = vuetify;
Vue.prototype.$store        = store;
Vue.prototype.API_BASE_URL  = process.env.VUE_APP_API_URL;
Vue.prototype.$uploadBaseUrl = getUploadBaseUrl;
Vue.prototype.$resolveUploadUrl = resolveUploadUrl;

import pinia from './pinia';

// ── Init app ──────────────────────────────────────────
const app = new Vue({
  vuetify,
  router,
  store,
  pinia,
  i18n,
  created() {
    // Restore dark/light theme from localStorage
    store.dispatch('theme/initTheme');
    const isDark = store.state.theme.isDark;
    if (isDark) {
      document.body.classList.add('dark-mode');
      vuetify.framework.theme.dark = true;
    }
  },
  render: h => h(App)
});

app.$mount('#app');
